module.exports = __webpack_public_path__ + "img/256x256_square.5e00bf50.svg";